import script from "./UserCreatePermission.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCreatePermission.vue?vue&type=script&setup=true&lang=js"

import "./UserCreatePermission.vue?vue&type=style&index=0&id=13096939&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13096939"]])

export default __exports__